<template>
  <div class="sub-layout">
    <div class="sub_toptit">
      <h1>GUIDELINE</h1>
    </div>

    <div class="contentBox">
      <div class="sub_container">

        <div class="abgtitle">
            <h1>KOREADERMA 2025</h1>
        </div>

        <div class="agtitle">
            <h4>01. Rules and instructions</h4>
        </div>

        <div class="agboxwrap">
            <div class="agbox">
                <div class="agtxt">
                    <div class="agdinfo"><b>Abstract Submission<br>
                        </b>
                        <p></p>
                        <h3>by July 13(Sun), 2025</h3>
                    </div>
                    <div class="agdinfo agdinfo1">
                        <p><b>Abstract Acceptance Notification</b></p>
                        <h3>July 21(Mon) to 25(Fri), 2025</h3>
                    </div>
                    <div class="btnbox">
                        <router-link to="/applyforlecturesNew/0/abstract" class="btn" >
                            <span>Go to Submission</span>
                            <i class="pi pi-arrow-right"></i>
                        </router-link>
                    </div>
                </div>
                <div class="agimg">
                    <img src="@/assets/img/aglogo.jpg">
                </div>
            </div>
        </div>

        <div class="agul mb3rem">
            <ul>
                <li>Abstracts for oral and poster presentations will represent a vital component of the scientific program at the KOREADERMA 2025.</li>
                <li>Please submit your abstract by <b>July 13(Sun), 2025</b>. An abstract will be evaluated by the KOREADERMA 2025 scientific committee, and you will be notified from <b>July 21(Mon) to 25(Fri), 2025</b> regarding the outcome of your submission.</li>
                <li>Abstracts must be submitted online on the main website.</li>
            </ul>
        </div>

        <div class="agtitle">
            <h4>02. Rules for abstract submission</h4>
        </div>

        <div class="agul mb3rem agul2">
            <ul>
                <li>Authors are required to indicate their preference for either oral, poster presentation, but all decisions will be made by the organizing committee of KOREADERMA 2025 whose determination is final.
                </li>
                <li>All notices will be issued according to the e-mail address of the first author of the article.</li>
                <li>Submitted abstracts should not have been published in any other journals and/or online publications, nor presented at any previous international congress. However, as long as the original work is referenced, it does not disqualify. Any former presentation at national meetings and/or non-medical aesthetic specialists may also be accepted.</li>
                <li>Instructions regarding the preparation of posters and information on projections facilities will be included with the notification of acceptance.</li>
                <li>Outstanding oral presentations will be rewarded (specifications to be updated).</li>
                <li>Submission of an abstract indicates that:
                    <ul class="agsoul">
                        <li>The author(s) agree to comply with the abstract submission and presentation rules.</li>
                        <li>The presentation is based on scientific and/or clinical methods that are ethical and valid.
                        </li>
                        <li>The author(s) have contributed to and approved the abstract and its entire contents.</li>
                        <li>The presenting author agrees to register, attend, and present the abstract at KOREADERMA 2025.</li>
                    </ul>
                </li>
            </ul>
            <div class="rules_img"><img src="@/assets/img/agimg1.png" alt=""></div>
        </div>

        <div class="agtitle">
            <h4>03. Instructions for abstract preparation (Specific guidance on formatting)</h4>
        </div>

        <div class="agul">
            <ul>
                <li>Abstracts must be written and presented in English.</li>
                <li>Abstracts will be reproduced as submitted by the author. Content may be rejected if it does not
                    feature actual data or is poorly drafted.</li>
                <li>The lecture title, content, and abstract must remain strictly unbiased and cannot contain any
                    product/device/company name or any brand name. Submissions will be withdrawn without notice if they
                    utilize any materials created by a commercial entity and include promotional messages and/or
                    corporate logos.</li>
            </ul>
        </div>

        <div class="agbluewrap">
            <div class="agbluebox">
                <div class="agblue1">
                    <h2>Title</h2>
                    <div class="agul">
                        <ul>
                            <li>All abstract titles must not exceed 25 words.</li>
                            <li>Use a concise, descriptive title that indicates the content of the abstract.</li>
                            <li>Avoid using abbreviations.</li>
                            <li>Commercial trade names for drugs, devices, products and services must not be included in
                                the title.</li>
                        </ul>
                    </div>
                </div>
                <div class="agblue1">
                    <h2>Authors</h2>
                    <div class="agul">
                        <ul>
                            <li>Names and surnames for each author must be provided.</li>
                            <li>Please do not include degrees or titles.</li>
                            <li>Presenting authors’ names will be underlined and the corresponding authors’ names will
                                be in bold.</li>
                        </ul>
                    </div>
                </div>
                <div class="agblue1">
                    <h2>Affiliations</h2>
                    <div class="agul">
                        <ul>
                            <li>Each author should be listed by department, institution, city, and country.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="agbluewrap agbluewrap1">
            <div class="agbluebox">
                <div class="agblue1 agblue2">
                    <h2>Main body</h2>
                    <div class="agul">
                        <ul>
                            <li>Abstracts should not exceed 250 words (excluding the title, authors, and keywords).</li>
                            <li>The body of the abstract text must be formatted with the following subheadings as
                                appropriate. Each sub-heading should be formatted in bold text, beginning on a new line,
                                and be followed by a colon and space. The text for the subsection should begin
                                immediately after the colon and space (sample below):<br>
                                <span class="lib">l Background :<br>
                                    l Objective :<br>
                                    l Methods :<br>
                                    l Results :<br>
                                    l Conclusions :</span></li>
                            <li>Drugs, devices, products, and services should be identified by generic names only within
                                the abstract. Data must be given in units (The international metric system is
                                preferred). No references, tables, charts, or images are allowed.</li>
                        </ul>
                    </div>
                </div>
                <div class="agblue1 agblue3">
                    <h2>Keyword(s)</h2>
                    <div class="agul">
                        <ul>
                            <li>A minimum of one (1) and a maximum of three (3) keywords reflecting the contents of the
                                abstract should be provided.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="boxwrap">
            <div class="agtitle">
                <h4>04. Abstract Thematic Topics</h4>
                <p>Abstracts will be classified into thematic areas. Please indicate the appropriate topic classification to
                    which your abstract belongs.</p>
            </div>
            <div class="keyword agul row">
                <ul>
                    <li>Acne scar</li>
                    <li>Biostimulator & Skin booster</li>
                    <li>Body contouring</li>
                    <li>Cosmeceuticals</li>
                    <li>Dermatologic surgery</li>
                    <li>EBD, others</li>
                    <li>EBD, pigmentary</li>
                    <li>EBD, skin lifting, tightening, and rejuvenation</li>
                    <li>Filler - (1) upper facey</li>
                    <li>Filler - (2) mid-face</li>
                    <li>Hair restoration</li>
                    <li>Other</li>
                </ul>
                <ul>
                    <li>Pigmentary disorders - (1) melasma</li>
                    <li>Pigmentary disorders - (2) lentigo</li>
                    <li>Pigmentary disorders - (3) others</li>
                    <li>Pore</li>
                    <li>Rejuvenation</li>
                    <li>Rosacea</li>
                    <li>Scar</li>
                    <li>Skin disease</li>
                    <li>Thread</li>
                    <li>Toxin</li>
                    <li>Vascular lesion</li>
                </ul>
            </div>
        </div>

        <div class="boxwrap">
            <div class="agtitle ">
                <h4>05. Acceptance notification</h4>
                <p>Authors will be notified from July 21(Mon) to 25(Fri), 2025 of the acceptance status of their submission, including the assignment of presentation format.
Detailed instructions regarding requirements and instructions for presentations will also be provided at that time.</p>
            </div>
        </div>

        <div class="boxwrap">
            <div class="agtitle">
                <h4>06. Requirements notification for oral presentation and e-poster</h4>
                <p>Oral presentation and e-poster requirements will be posted at our website after the acceptance
                    notification and the secretariat will notify information personally.</p>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>




export default {
  name: 'Guideline',
  data() {
    return {

    };
  },
  components: {

  },
  methods: {
 
  },
  mounted() {



  },
  methods: {
    
  },
};
</script>